import { useState } from "react";
import { useLeagueId } from "../hooks/useLeagueId";

// Components
import Header from "./components/Header";

// Images
import logo from "../img/COBRADOR_LEAGUE_LOGO_02_FINAL.png";
import vortem from "../img/vortem4.png";

// 📚 Narrative chapters with PDF comics
const chapters = [
  {
    id: "phase1",
    title: "El Velo de Sangre",
    subtitle: "Crónicas del Subsector Vortem",
    pdf: "/pdfs/Comic_Velo_de_Sangre - Intoduccion.pdf"
  },
  {
    id: "phase2",
    title: "Ecos del Disforme",
    subtitle: "La guerra se extiende",
    pdf: "/pdfs/ecos-del-disforme.pdf"
  }
];

const Chronicles = () => {
  const idleague = useLeagueId();
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeChapter, setActiveChapter] = useState(chapters[0]);

  if (!idleague) {
    return (
      <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center">
        <p className="text-gray-400">No se ha seleccionado una liga válida.</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-900 text-white flex flex-col">
      <Header
        logo={logo}
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
        idleague={idleague}
      />

      {/* BANNER */}
      <div className="w-full flex flex-col md:flex-row items-center p-6 gap-6">
        <img
          src={vortem}
          alt="Subsector Vortem"
          className="w-full md:w-1/3 h-64 object-contain"
        />

        <div className="md:w-2/3 text-center md:text-left">
          <h1 className="text-4xl font-bold mb-2">El Velo de Sangre: Crónicas del Subsector Vortem</h1>
          <p className="text-gray-300 text-lg">
            Narrativa visual de la campaña. Cada capítulo representa un cómic
            que documenta los eventos clave del conflicto.
          </p>
        </div>
      </div>

      {/* CHAPTER SELECTOR */}
      <div className="flex justify-center gap-4 px-4 mb-8 flex-wrap">
        {chapters.map((chapter) => (
          <button
            key={chapter.id}
            onClick={() => setActiveChapter(chapter)}
            className={`px-4 py-2 rounded-lg text-sm font-semibold transition
              ${
                activeChapter.id === chapter.id
                  ? "bg-red-700"
                  : "bg-gray-800 hover:bg-gray-700"
              }`}
          >
            {chapter.title}
          </button>
        ))}
      </div>

      {/* PDF COMIC VIEWER */}
      <div className="flex-1 max-w-6xl mx-auto px-4 pb-12 w-full">
        <div className="text-center mb-4">
          <h2 className="text-3xl font-bold">{activeChapter.title}</h2>
          <p className="text-gray-400 italic">{activeChapter.subtitle}</p>
        </div>

        <div className="bg-gray-800 rounded-xl shadow-lg overflow-hidden">
          <iframe
            src={activeChapter.pdf}
            title={activeChapter.title}
            className="w-full h-[80vh] bg-black"
          />
        </div>

        <div className="text-center mt-4">
          <a
            href={activeChapter.pdf}
            download
            className="inline-block bg-red-700 hover:bg-red-800 px-4 py-2 rounded transition"
          >
            Descargar cómic (PDF)
          </a>
        </div>
      </div>
    </div>
  );
};

export default Chronicles;
